module.exports = __webpack_public_path__ + "static/media/calendar-schedule.1feed97f.png";